import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ReviewRequestConfig, useReviews, ReviewFieldSelection, UserFieldSelection, ReviewResponseFieldSelection, ReviewOrdering } from '@/lib/hooks/use-reviews';
import { Reviews } from './reviews.react-component';
import type { ReviewsContext } from './types';
import styles from './reviews-container.module.scss';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
export interface ReviewsContainerProps {
  courseId: number;
  className?: string;
}
export const ReviewsContainer = t0 => {
  const $ = _c(21);
  const {
    courseId,
    className
  } = t0;
  const {
    rating
  } = useClpCourse();
  let t1;
  if ($[0] !== courseId) {
    t1 = courseId.toString();
    $[0] = courseId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [ReviewFieldSelection.RATING];
    t3 = [UserFieldSelection.IMAGE, UserFieldSelection.DISPLAY_NAME];
    t4 = [ReviewResponseFieldSelection.CONTENT, ReviewResponseFieldSelection.USER, ReviewResponseFieldSelection.CREATED, ReviewResponseFieldSelection.ID];
    t5 = [ReviewOrdering.REVIEW_SCORE_RANK, ReviewOrdering.CREATED_DESC];
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1) {
    t6 = {
      courseId: t1,
      pageSize: 12,
      isTextReview: true,
      fields: t2,
      userFields: t3,
      responseFields: t4,
      ordering: t5
    };
    $[6] = t1;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const reviewsConfig = t6;
  const {
    data: reviews,
    isLoading,
    ratingDistribution,
    averageRating
  } = useReviews(reviewsConfig);
  const courseAverageRating = rating?.average ?? averageRating;
  const t7 = reviewsConfig.page ?? 1;
  let t8;
  if ($[8] !== t7) {
    t8 = t7.toString();
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== courseAverageRating || $[11] !== courseId || $[12] !== ratingDistribution || $[13] !== t8) {
    t9 = {
      averageRating: courseAverageRating,
      ratingDistribution,
      courseId,
      page: t8
    };
    $[10] = courseAverageRating;
    $[11] = courseId;
    $[12] = ratingDistribution;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const reviewsRatings = t9;
  let t10;
  if ($[15] !== className || $[16] !== courseId || $[17] !== isLoading || $[18] !== reviews || $[19] !== reviewsRatings) {
    t10 = <Reviews reviews={reviews} isLoading={isLoading} reviewsRatings={reviewsRatings} reviewableObjectType="course" reviewableObjectId={courseId} className={className} courseId={courseId} mobileCarouselClassName={styles["carousel-mobile-full-bleed-grid"]} tabletCarouselClassName={styles["carousel-tablet-full-bleed-single-item-grid"]} />;
    $[15] = className;
    $[16] = courseId;
    $[17] = isLoading;
    $[18] = reviews;
    $[19] = reviewsRatings;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};